import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('firebase_id_token');
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (token && user) {
    const adminRedirectUrl = process.env.REACT_APP_ADMIN_REDIRECT_URL_AFTER_LOGIN || '/admin/users';
    return <Navigate to={user.is_admin ? adminRedirectUrl : '/chat'} replace />;
  }

  return children;
};

export default PublicRoute;
